// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ToDo_wrap__EDg3E","title":"ToDo_title__2US2f"};